import React, { useState } from 'react'
import "./Services.css";

const Services = () => {
    const [toggleState, setToggleState] = useState(0);

    const toggleTab = (index) => {
        setToggleState(index)
    }

    return (
        <section className="services section" id="services">
            <h2 className="section__title">Services</h2>
            <span className="section__subtitle">What i offer</span>
            <div className="services__container container grid">

                <div className="services__content">
                    <div>
                        <i className="uil uil-web-grid services__icon"></i>
                        <h3 className="services__title"> Front-End Development  <br /> Expertise</h3>
                    </div>

                    <span className="services__button" onClick={() =>
                        toggleTab(1)}>
                        View More
                        <i className="uil uil-arrow-right
                         services__button-icon"></i></span>

                    <div className={toggleState === 1 ? "services__modal active-modal" : "services__modal"}>

                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times 
                                services__modal-close"></i>

                            <h3 className="services__modal-title">Front-End Development</h3>
                            <p className="services__modal-description">Service with more than 1 years of experience. Providing quality work to clients and companies.</p>

                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">Responsive Web Design.</p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">User Interface (UI) Design.</p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">HTML/CSS Mastery.</p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">
                                        JavaScript Frameworks.</p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">Cross-Browser Compatibility.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="services__content">
                    <div>
                        <i className="uil uil-arrow services__icon"></i>
                        <h3 className="services__title"> Back-End Development  <br /> Excellence</h3>
                    </div>
                    <span className="services__button" onClick={() =>
                        toggleTab(2)}>View More
                        <i className="uil uil-arrow-right
                         services__button-icon"></i></span>

                    <div className={toggleState === 2 ? "services__modal active-modal" : "services__modal"}>


                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times 
                                services__modal-close"></i>

                            <h3 className="services__modal-title"> Back-End Development</h3>
                            <p className="services__modal-description">Service with more than 1 years of experience. Providing quality work to clients and companies.</p>

                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">Server-Side Programming.</p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">Database Management.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">API Development.</p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">Authentication and Authorization.</p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">
                                        Performance Optimization.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="services__content">
                    <div>
                        <i className="uil uil-edit services__icon"></i>
                        <h3 className="services__title"> Additional <br /> Services</h3>
                    </div>
                    <span className="services__button" onClick={() =>
                        toggleTab(3)}>View More
                        <i className="uil uil-arrow-right
                         services__button-icon"></i></span>

                    <div className={toggleState === 3 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times 
                                services__modal-close"></i>

                            <h3 className="services__modal-title">Additional Services</h3>
                            <p className="services__modal-description">Service with more than 1 years of experience. Providing quality work to clients and companies.</p>

                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">Version Control and Collaboration.</p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">Testing and Debugging.</p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">Deployment and Continuous Integration.</p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">
                                        Documentation and Communication.</p>
                                </li>


                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle service__modal-icon"></i>
                                    <p className="services__modal-info">Client Satisfaction and Project Management.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default Services
